module.exports = __webpack_public_path__ + "img/ico-trash.0fb6cd6c.svg";